module.exports = __webpack_public_path__ + "img/title-lp-text.da03487.svg";